import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { fetchAllTeams } from "~Shared/store/actions/team/teamActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToTeam = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.DELETE) {
            dispatch(fetchAllTeams())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Team Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
